<button class="close modalClose" mat-button (click)="onNoClick()" tabindex="-1">
  X
</button>

<h1 mat-dialog-title>Advanced filter logic</h1>
<span class="filters-icon-wrapper">
  <button
    mat-button
    class="button_small"
    (click)="addFilter()"
    aria-label="add"
    style="margin-right: 10px"
  >
    Add Filter
  </button>
</span>
<div mat-dialog-content [formGroup]="filterForm">
  <mat-drawer-container class="filter-container">
    <mat-drawer-content #scroll>
      <span class="filters-table-wrapper">
        <table class="filtersTable">
          <tr>
            <td
              colspan="7"
              cdkDropList
              class="conditions-list"
              (cdkDropListDropped)="drop($event)"
            >
              <div
                formArrayName="filterConditionList"
                *ngFor="
                  let filterFormGroups of filterFormGroups.controls;
                  let i = index;
                  let l = count
                "
                cdkDrag
              >
                <ng-container [formGroupName]="i">
                  <div class="conditions-box" [ngStyle]="indentItem(i)">
                    <div
                      class="example-custom-placeholder"
                      *cdkDragPlaceholder
                    ></div>

                    <span
                      style="width: calc(100% - 150px); display: inline-block"
                    >
                      <label>Filter: </label>
                      <mat-form-field style="width: 300px">
                        <mat-select
                          formControlName="filterId"
                          name="filterId"
                          aria-label="filterId"
                        >
                          <mat-option
                            *ngFor="
                              let reportField of filterFields;
                              let i = index
                            "
                            [value]="
                              reportField.id || reportField.dataPoint.data.id
                            "
                            >{{
                              reportField.name ||
                                reportField.dataPoint.data.name
                            }}</mat-option
                          >
                        </mat-select>
                      </mat-form-field>
                    </span>
                    <span
                      style="
                        width: 150px;
                        display: inline-block;
                        text-align: right;
                      "
                    >
                      <fa-icon
                        [icon]="faTrash"
                        class="grouping"
                        (click)="deleteItem(i)"
                        style="margin-top: 13px; margin-left: 13px"
                        matTooltip="Remove this filter"
                        matTooltipPosition="right"
                      ></fa-icon>
                      <fa-icon
                        [icon]="faChevronCircleLeft"
                        class="grouping"
                        (click)="groupItem('left', i)"
                        style="margin-top: 13px; margin-left: 25px"
                        [ngStyle]="checkLeft(i)"
                        matTooltip="Move this filter left"
                        matTooltipPosition="right"
                      ></fa-icon>
                      <fa-icon
                        [icon]="faChevronCircleRight"
                        class="grouping"
                        (click)="groupItem('right', i)"
                        style="
                          margin-top: 13px;
                          margin-left: 15px;
                          margin-right: 15px;
                        "
                        [ngStyle]="checkRight(i)"
                        matTooltip="Move this filter right"
                        matTooltipPosition="right"
                      ></fa-icon>
                    </span>
                  </div>

                  <mat-select
                    *ngIf="i + 1 != l"
                    [ngStyle]="indentCondition(i)"
                    class="conditional"
                    formControlName="filterOperation"
                    name="filterOperation"
                    aria-label="And / Or"
                  >
                    <mat-option value="and">AND</mat-option>
                    <mat-option value="or">OR</mat-option>
                  </mat-select>
                </ng-container>
              </div>
            </td>
          </tr>
        </table>
      </span>

      <BR /><BR />
    </mat-drawer-content>
    <mat-drawer mode="side" position="end" opened class="right-side">
      <span class="applied">APPLIED FILTERS </span>
      <span class="applied2">for reference</span>
      <div id="filterList">
        <div *ngFor="let reportField of filterFields; let i = index">
          <div class="reportField-box">
            <div
              class="canvasFields"
              id="filter-{{ i }}"
              [ngClass]="{ selected: selectedIndex == i }"
            >
              <div class="far-left">{{ i + 1 }}.</div>
              <div class="left">
                <app-datapoint-icons
                  [type]="reportField.type || reportField.dataPoint.data.type"
                ></app-datapoint-icons>
              </div>
              <div
                class="right"
                matTooltip="{{
                  reportField.name ||
                    reportField.fields.data[0].dataPoint.data.name
                }}"
                matTooltipPosition="right"
              >
                <div class="title">
                  {{
                    reportField.name ||
                      reportField.fields.data[0].dataPoint.data.name
                  }}
                </div>
                <div class="type"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="darrinTestingFlag">
        <div class="filterLogicDarrin">FOR DARRIN USE ONLY</div>
        <div class="filterLogicDarrin2">not for public consumption</div>
        <pre class="filterLogic" [innerHTML]="filterLogic"></pre>
      </ng-container>
    </mat-drawer>
  </mat-drawer-container>
</div>
<div mat-dialog-actions>
  <div
    class="filterLogicUser"
    [innerHTML]="filterLogicUser"
    *ngIf="filterLogicUser != ''"
  ></div>
  <div class="filterLogicUser generating" *ngIf="filterLogicUser == ''">
    Generating Logic
  </div>
  <button mat-button mat-dialog-close class="button_small cancel">
    cancel
  </button>
  <button
    mat-button
    class="button_small"
    (click)="onConfirmClick()"
    [disabled]="!filterForm.valid"
  >
    apply
  </button>
</div>
